import React, { useState, useRef,useEffect } from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Ab.css";
import { FaPlay, FaPause } from 'react-icons/fa';
import { useSpring, animated } from '@react-spring/web';
import RRHomeBanners1 from'../../images/RR Home Banners (1).webp'
import RRHomeBanners2 from'../../images/RR Home Banners (2).webp'
import RRHomeBanners3 from'../../images/RR Home Banners (3).webp'
import RRHomeBanners4 from'../../images/RR Home Banners (4).webp'
import RRHomeBanners5 from'../../images/RR Home Banners (5).webp'
import RRHomeBanners6 from'../../images/RR Home Banners (6).webp'
import RRHomeBanners7 from'../../images/RR Home Banners (7).webp'
import RRHomeBanners8 from'../../images/RR Home Banners (8).webp'
import RRHomeBanners9 from'../../images/RR Home Banners (9).webp'
import RRHomeBanners10 from'../../images/RR Home Banners (10).webp'
import RRHomeBanners11 from'../../images/RR Home Banners (11).webp'
import RRHomeBanners12 from'../../images/RR Home Banners (12).webp'
import RRHomeBanners13 from'../../images/RR Home Banners (13).webp'
import RRHomeBanners14 from'../../images/RR Home Banners (14).webp'
import s2 from'../../images/RR-Landing-11 (1).png'
import s3 from'../../images/RR-Landing-4.png'
import s4 from'../../images/RR-Landing-11 (2).png'
import s5 from'../../images/RR-Landing-9.jpeg'
import s6 from'../../images/RR-Landing-11 (4).png'
import s7 from'../../images/RR-Landing-8.jpeg'
import s8 from'../../images/RR-Landing-11 (3).png'
import s9 from'../../images/RR-Landing-11 (5).png'
import arrow from "../../images/round.png";
import arrow1 from "../../images/arrow-2.png";
import ved from "../../videos/dji.MP4";
import thumb from "../../images/landing-page (1).webp";
import ring from "../../images/wedding ring.png";
import imge1 from "../../images/ic-1.png";
import imge2 from "../../images/ic-2.png";
import imge3 from "../../images/ic-3.png";
import imge4 from "../../images/ic-4.png";
import imge5 from "../../images/ic-5.png";
import god from "../../images/promise.webp";
import theer from "../../images/theer.png";
import wd1 from "../../images/hall.webp";
import wd2 from "../../images/wd-2.png";
import arr2 from "../../images/arrow-2.png";
import Accordion from "../Faq/Faq";
import Testi from "../testimonial/Testi";
import reception from '../../images/reception.webp'
import parties from '../../images/parties.webp'
import events from '../../images/events.jpg'
import babyshower from '../../images/babyshower.webp'
import corporate from '../../images/Corporate event.jpg'
import happy1 from '../../images/happy1.webp'
import happy2 from '../../images/happy2.webp'
import happy3 from '../../images/happy3.webp'
import happy4 from '../../images/happy4.webp'
import happy5 from '../../images/happy5.webp'
import happy6 from '../../images/happy6.webp'
import happy7 from '../../images/img6.png'
import { Hall } from "../Hall/Hall";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from "react-router-dom";
import { div } from "three/examples/jsm/nodes/Nodes.js";
import Reels from "../../videos/Reels.mp4"
import RRGallery from "../RR_Videos/RR_Video";
import RRMrgVideos from "../RR_Mrg_Videos/RR_Mrg";

// ..



AOS.init();

const faqData = [
  { question: "What is React?", answer: "React is a JavaScript library for building user interfaces." },
  { question: "Why use React?", answer: "React is flexible, efficient, and has a large community and ecosystem." },
  { question: "How does React work?", answer: "React creates a virtual DOM and synchronizes it with the real DOM efficiently." },
  // Add more FAQs here
];

const VideoPlayer = () => {
  


  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const togglePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    
  };
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);}

    useEffect(() => {
      const handlePlay = () => setIsPlaying(true);
      const handlePause = () => setIsPlaying(false);
  
      const videoElement = videoRef.current;
      if (videoElement) {
        videoElement.addEventListener('play', handlePlay);
        videoElement.addEventListener('pause', handlePause);
      }
  
      return () => {
        if (videoElement) {
          videoElement.removeEventListener('play', handlePlay);
          videoElement.removeEventListener('pause', handlePause);
        }
      };
    }, []);
  

  return (
    <div className="container-fluid fullwidth-container" id="main-content">
     <div className="outer" >
      <div className="container-fluid fullwidth-container head-container">
        <div className="row one" data-aos="fade-up" data-aos-duration="1500">
          <div className="col-8 col-sm-6 col-xxl-4 heading">
            <h1>
            Best Marriage <br/>Hall In Coimbatore
            </h1>
          </div>
          <div className="col">
            <img className="ring" src={ring} alt="" />
          </div>
          <div className="col-0 col-sm-4  head-p hide">
            <p>
            Every marriage is a unique story filled with laughter, dreams, and heartfelt moments. At RR Thoranam Mahal, we turn your wedding into a magical celebration as extraordinary as your love.
            </p>
          </div>
        </div>
   
        </div>
        </div>
     <div className="outer">
      <div className="container-fluid fullwidth-container main-slider">
        
  
    
      <Slider className=" " {...settings} >
      <div  data-aos="zoom-in-up" data-aos-duration="1700" >
        <img className="carousel" src={RRHomeBanners1} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners2} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners3} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners4} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners5} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners6} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners7} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners8} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners9} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners10} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners11} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners12} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners13} alt="" />
      </div>
      <div  data-aos="fade-down" data-aos-duration="1700">
      <img className="carousel" src={RRHomeBanners14} alt="" />
      </div>
      
        </Slider>
        
        {/* . */}
        </div>
        </div>
         
        <div className="outer">
        <div className="container-fluid ab-container">

        <div className="row section-1 pt-1 pt-sm-3  pt-lg-4">
          <div className="icons"  data-aos="fade-up" data-aos-duration="1500">
            <div className="ic-items">
              <img src={imge1} alt="Icon 1" />
              <h6>CCTV SURVEILLANCE</h6>
            </div>
            <div className="ic-items">
              <img src={imge2} alt="Icon 2" />
              <h6>FULLY AC HALL</h6>
            </div>
            <div className="ic-items">
              <img src={imge3} alt="Icon 3" />
              <h6>VINAYAGAR TEMPLE</h6>
            </div>
            <div className="ic-items ">
              <img src={imge4} alt="Icon 4" />
              <h6>CAR PARKING</h6>
            </div>
            <div className="ic-items hid">
              <img src={imge5} alt="Icon 5" />
              <h6>CCTV SURVEILLANCE</h6>
            </div>
          </div>
        </div>

        <div className="row section-2">
          <div className="col-12 col-sm-12 col-md-6  col-lg-5 col-xxl-4 mt-0  ">
            <div className="flexu">
              <h2 className="sub-head" data-aos="fade-up" data-aos-duration="1500">Our Promise</h2>
              <img className="theer hidd" src={theer} alt="Promise Image" data-aos="fade-down-left" data-aos-duration="1500"/>
            </div>
            <img className="god" src={god} alt="God Image" data-aos="fade-up" data-aos-duration="1500" />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xxl-7 ">
            <img className="theer hidu" src={theer} alt="Theer Image" data-aos="fade-down-left" data-aos-duration="1500"/>
            <p className="mt-4 ab-p just "  data-aos="fade-left" data-aos-duration="1500">
               Plan your dream wedding at RR Thoranam Mahal, the best wedding hall in Coimbatore, nestled just 20 minutes from the heart of the city. We take pride in showcasing the grandeur of traditional weddings, with venues adorned with intricate details that allow you to celebrate your special day with age-old rituals in a captivating atmosphere. We offer stunning gardens, elegant banquet halls, and versatile open spaces that can be transformed to suit the unique vision of your event. Whether you're planning a grand wedding celebration, a sophisticated business conference, or a heartwarming family gathering, RR Thoranam Mahal provides the perfect setting. With a reputation built on quality and professionalism, we are dedicated to making your special day truly unforgettable.
            </p>
            <div className="row mt-3 mt-sm-3  mt-lg-2 ">
              <div className="col-10 col-sm-5 "  data-aos="fade-left" data-aos-duration="1500">
                <h5 className="ab-h">View our Facilities</h5>
                <p className="ab-p ">
                Explore our exceptional facilities and envision the possibilities for your dream celebration.
                </p>
                <Link className='read-more-button' to="./Facilities">
                        <span className='lines'></span>
                        See More</Link>
              </div>
              <div className="col"></div>
            </div>
          </div>
        </div>
        <Hall/>
        <div className=" section-4 ">
          <div className="row mt-5 p-0 one ">
            <div className="col">
              <div className="row blue-moon">
                <h2 className="sub-head" data-aos="fade-up" data-aos-duration="1500">Once In A Blue Moon</h2>
                <p className="mt-0 mt-sm-2 moon-para" data-aos="fade-up" data-aos-duration="1500">
                Our gallery showcases stunning visuals of the transformation  of our spaces<br/> for weddings, corporate events, and a variety of other occasions.
                </p>
              </div>
              <div className="row gap-3 gap-sm-0 gap-lg-0 gap-xxl-0 mt-3">
                <div className="col-12 col-sm-6 col-lg-6 wd" data-aos="zoom-in-right" data-aos-duration="1500">
                  <div className="image-container" >
                    <img className="wd-1" src={reception} alt="Party Image" />
                  </div>
                  <div className="fl">
                  <Link className='gallery-button' to="./Gallery">
                      
                        Reception</Link>
                        <img className="gallery-arrow" src={arr2} alt="Arrow Icon" />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-6 wd" data-aos="zoom-in-left" data-aos-duration="1500">
                  <div className="image-container">
                    <img className="wd-1" src={wd2} alt="Wedding Image" />
                  </div>
                  <div className="fl">
                  <Link className='gallery-button' to="./Gallery">
                        
                        Wedding</Link>
                        <img className="gallery-arrow" src={arr2} alt="Arrow Icon" />
                  </div>
                </div>
              </div>
              <div className="row gap-3 gap-sm-0 gap-lg-0 gap-xxl-0 mt-3">
                <div className="col-12 col-sm-6 col-lg-6 wd" data-aos="zoom-in-right" data-aos-duration="1500">
                  <div className="image-container" >
                    <img className="wd-1" src={parties} alt="Party Image" />
                  </div>
                  <div className="fl">
                  <Link className='gallery-button' to="./Gallery">
                      
                      Parties</Link>
                      <img className="gallery-arrow" src={arr2} alt="Arrow Icon" />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-6 wd"  data-aos="zoom-in-left" data-aos-duration="1500">
                  <div className="image-container">
                    <img className="wd-1" src={corporate} alt="Wedding Image" />
                  </div>
                  <div className="fl">
                  <Link className='gallery-button' to="./Gallery">
                      
                  Corporate Events</Link>
                      <img className="gallery-arrow" src={arr2} alt="Arrow Icon" />
                  </div>
                </div>
              </div>
              <div className="row gap-3 gap-sm-0 gap-lg-0 gap-xxl-0 mt-3">
                <div className="col-12 col-sm-6 col-lg-6 wd" data-aos="zoom-in-right" data-aos-duration="1500">
                  <div className="image-container" >
                    <img className="wd-1" src={babyshower} alt="Party Image" />
                  </div>
                  <div className="fl">
                  <Link className='gallery-button' to="./Gallery">
                      
                      Baby Shower</Link>
                      <img className="gallery-arrow" src={arr2} alt="Arrow Icon" />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-6 wd"  data-aos="zoom-in-left" data-aos-duration="1500">
                  <div className="image-container">
                    <img className="wd-1" src={events} alt="Wedding Image" />
                  </div>
                  <div className="fl">
                  <Link className='gallery-button' to="./Gallery">
                      
                      Get Together</Link>
                      <img className="gallery-arrow" src={arr2} alt="Arrow Icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" mt-5 mt-sm-5">
          <div className="contain">
          <h2 className="wedding-gallery-head">Happy Moments</h2>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-3 gallery-col-home" data-aos="zoom-in" data-aos-duration="4000"><img className="happyimg" src={happy1} alt="" srcset="" /></div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-3 gallery-col-home" data-aos="zoom-in" data-aos-duration="3800"><img className="happyimg" src={happy2} alt="" srcset="" /></div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-3 gallery-col-home" data-aos="zoom-in" data-aos-duration="2000"><img className="happyimg img-mt"  src={happy3} alt="" srcset="" /></div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-3 gallery-col-home" data-aos="zoom-in" data-aos-duration="2000"><img className="happyimg img-mt" src={happy4} alt="" srcset="" /></div>
            </div>
            <div className="row mt-sm-4 mt-0">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 gallery-col-home" data-aos="zoom-in" data-aos-duration="3000"><img className="happyimg" src={happy5} alt="" srcset="" /></div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 gallery-col-home" data-aos="zoom-in" data-aos-duration="2000"><img className="happyimg" src={happy6} alt="" srcset="" /></div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 gallery-col-home" data-aos="zoom-in" data-aos-duration="1000"><img className="happyimg"  src={happy7} alt="" srcset="" /></div>
            </div>
          </div>

          
        </div>

        <div className="row mt-5 mt-sm-5">
          <div className="col ">
            <div className="row " data-aos="fade-up" data-aos-duration="1500"><h1 className="youtube-head" >Wedding Videos to Cherish</h1></div>
            <div className="row gallery-row">
              <div className="col-11 col-sm-10 col-md-10 col-lg-5" data-aos="zoom-out-right" data-aos-duration="1500">
              <div className="youtube-vid">
                <iframe  className="youtube-iframe1"  src="https://www.youtube.com/embed/K9zVGDpKDfs?si=6KxFrmURtK8fhyNe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
              </div>
              <div className="col-11 col-sm-10 col-md-10 col-lg-5" data-aos="zoom-out-left" data-aos-duration="1500">
                <div className="youtube-vid">
                <iframe className="youtube-iframe1"  src="https://www.youtube.com/embed/onyDLNyFnAU?si=yj_ZbS4zoKAXOzxa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div className="row mt-0 mt-sm-5  gallery-row">
              <div className="col-11 col-sm-10 col-md-10 col-lg-5 " data-aos="zoom-out-right" data-aos-duration="1500">
                <div className="youtube-vid">
                <iframe  className="youtube-iframe2"  src="https://www.youtube.com/embed/CDDFrxbXxpw?si=2X1kp0DE31NVoA3p" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
              <div className="col-11 col-sm-10 col-md-10 col-lg-5" data-aos="zoom-out-left" data-aos-duration="1500">
                <div className="youtube-vid">
                <iframe  className="youtube-iframe2"  src="https://www.youtube.com/embed/v2IXl0-edVA?si=ux1I9ut-Faw0A1ZQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
              <div className="col-11 col-sm-10 col-md-10 col-lg-5" data-aos="zoom-out-left" data-aos-duration="1500">
                <div className="youtube-vid">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/wRGPhpdhwg0?si=1t85v4eXbVuioz1Z" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
              
              
            </div>
           
          </div>
        </div>
        <div className="row mt-5 mt-sm-5">
          
      <div className="col">
        <div className="row" data-aos="fade-up" data-aos-duration="1500">
          <h1 className="youtube-head">Instagram Reels</h1>
        </div>
        <div className="row mt-0 mt-sm-5 reel-row">
          <div
            className="col-11 col-sm-10 col-md-10 col-lg-5"
            data-aos="zoom-out-right"
            data-aos-duration="1500"
          >
            <div className="youtube-vid" style={{ position: 'relative' }}>
              <video
                ref={videoRef}
                className="youtube-iframe3"
                src={Reels}
                title="Instagram Reels video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                 
              />
              <div
                className="play-pause-icon"
                style={{
                  display: isPlaying ? 'none' : 'block'
                  
                }}
                onClick={togglePlayPause}
              >
                <FaPlay />
              </div>
              <div
                className="pause-icon"
                style={{
                  display: isPlaying ? 'block' : 'none',
                }}
                onClick={togglePlayPause}
              >
                <FaPause />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      
      <RRGallery/>

        
   
          <Testi/>

        <div className="row  section-5" id="cm">
          <div className="col-11 col-sm-4">
            <h1 className="sub-head" data-aos="fade-up" data-aos-duration="4000">Book Us Now</h1>
            <div className="flex-1 gap-4 mt-4">
              <input className="" placeholder="Name" itemType="text" data-aos="fade-right" data-aos-duration="1800" />
              <input className=" " placeholder="Number" itemType="text" data-aos="fade-right" data-aos-duration="1800" />
              <input className=" pb-5" placeholder="message" itemType="text" data-aos="fade-right" data-aos-duration="1800"/>
              <button class="btn" data-aos="fade-up"
     data-aos-duration="1800">
                <i class="animation" ></i>SEND<i class="animation"></i>
              </button>
              <div></div>
            </div>
          </div>
          <div className="col-2 ">
            <div className="line" data-aos="fade-in-up" data-aos-duration="2000">.</div>
          </div>
          <div className="col-12 col-sm-6" data-aos="fade-left" data-aos-duration="2000">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.455413578012!2d76.86744217402027!3d11.004417454949072!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85ffe65bd978d%3A0x7672f8ac9242ddcc!2sRR%20Thoranam%20Mahal%20Best%20Wedding%20Halls%20in%20Coimbatore%20%7C%20Ac%20Marriage%20Halls%20%7C%20Kalyana%20Mandapam!5e0!3m2!1sen!2sin!4v1718863245032!5m2!1sen!2sin"
              width="500"
              height="400"
              allowfullscreen=""
              loading="lazy"
              className="map"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    </div>
    
  );
};









export default VideoPlayer;